export const JSONRPC_VERSION = '2.0';

const toHex = (bytes) =>
  Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

/**
 * @param {string} method
 * @return {string}
 */
export function generateId(method) {
  const random = crypto.getRandomValues(new Uint32Array(2));
  const data = `${method || ''}-${Date.now()}-${random[0]}-${random[1]}`;
  const bytes = new TextEncoder().encode(data);
  return toHex(bytes);
}

export function rpcRequest(method, params, id) {
  return {
    jsonrpc: JSONRPC_VERSION,
    method,
    params,
    id,
  };
}

export function rpcRequestString(method, params, id) {
  return JSON.stringify(rpcRequest(method, params, id));
}

// export const JSONRPC_VERSION = '2.0';

// /**
//  * @param {string} method
//  * @return {string}
//  */
// export function generateId(method) {
//   return Buffer.from([method, Date.now()].join('-')).toString('hex');
// }

// export function rpcRequest(method, params, id) {
//   return {
//     jsonrpc: JSONRPC_VERSION,
//     method,
//     params,
//     id,
//   };
// }

// export function rpcRequestString(method, params, id) {
//   return JSON.stringify(rpcRequest(method, params, id));
// }
